module.exports = __webpack_public_path__ + "img/networking.5aecdc92.jpg";